import React from 'react';
import { ClipboardList, Search, Network, HeartHandshake } from 'lucide-react';
const STEPS = [{
  number: '1',
  icon: ClipboardList,
  title: 'La familia solicita',
  text: 'A través de nuestro formulario de solicitud de ayuda'
}, {
  number: '2',
  icon: Search,
  title: 'Evaluamos el caso',
  text: 'Nuestro equipo revisa la situación y necesidades específicas de la familia'
}, {
  number: '3',
  icon: Network,
  title: 'Conectamos con aliados',
  text: 'Especialistas y profesionales de nuestra red de Alianzas Estratégicas'
}, {
  number: '4',
  icon: HeartHandshake,
  title: 'La familia recibe apoyo',
  text: 'Educación, terapias o evaluaciones según el caso aprobado'
}];
export function ProcessSection() {
  return <section id="como-funciona" className="mp-process-section" style={{
    background: 'white',
    padding: '80px 20px'
  }} data-id="element-264" data-mp="25gsxki8e7edb">
      <p style={{
      color: '#7DC920',
      fontSize: '11px',
      letterSpacing: '3px',
      fontWeight: 700,
      textAlign: 'center',
      marginBottom: '8px'
    }} data-id="element-265" data-mp="20o9ithxyyd6x">
        TRANSPARENCIA
      </p>
      <h2 className="mp-process-title" style={{
      fontSize: '38px',
      fontWeight: 800,
      textAlign: 'center',
      color: '#1a1a1a',
      marginBottom: '12px'
    }} data-id="element-266" data-mp="1wdcujqx6521t">
        ¿Cómo funciona tu donación?
      </h2>
      <p style={{
      fontSize: '16px',
      color: '#666',
      textAlign: 'center',
      marginBottom: '56px',
      maxWidth: '620px',
      marginLeft: 'auto',
      marginRight: 'auto'
    }} data-id="element-267" data-mp="1rd8e20w9g7bl">
        Cada donación sigue un proceso serio y verificable antes de llegar a una
        familia
      </p>
      <div className="mp-process-grid" style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gap: 0,
      maxWidth: '900px',
      margin: '0 auto',
      position: 'relative'
    }} data-id="element-268" data-mp="37sjcox9p2ej3">
        <div aria-hidden="true" className="mp-process-line" style={{
        position: 'absolute',
        top: '28px',
        left: '12.5%',
        right: '12.5%',
        height: '2px',
        background: 'linear-gradient(to right, #7DC920, #2d5a1b)',
        zIndex: 0
      }} data-id="element-269" data-mp="369jdi66hstxe" />
        {STEPS.map(({
        number,
        icon: Icon,
        title,
        text
      }) => <div key={number} style={{
        textAlign: 'center',
        position: 'relative',
        zIndex: 1,
        padding: '0 12px'
      }} data-id="element-270" data-mp="3p1klby18vuiy">
            <div className="flex items-center justify-center" style={{
          width: '56px',
          height: '56px',
          borderRadius: '50%',
          background: '#2d5a1b',
          color: 'white',
          fontSize: '20px',
          fontWeight: 800,
          margin: '0 auto 16px',
          border: '3px solid #7DC920'
        }} data-id="element-271" data-mp="3f96guxis89t3">
              <Icon size={22} color="white" data-id="element-272" data-mp="t3lcv7f0wtda" />
            </div>
            <h3 style={{
          fontSize: '16px',
          fontWeight: 700,
          color: '#1a1a1a',
          marginBottom: '6px'
        }} data-id="element-273" data-mp="t67i30efywsc">
              {title}
            </h3>
            <p style={{
          fontSize: '13px',
          color: '#666',
          lineHeight: 1.5
        }} data-id="element-274" data-mp="172ksxqogzzxu">
              {text}
            </p>
          </div>)}
      </div>
    </section>;
}